<template>
  <div class="create_wrapper custom_card p-4">
    <!-- CARD TITLE -->
    <div class="card-header border-0 pb-3 mb-4">
      <h3 class="card-title font-weight-bold" style="color: #783d73">
        <i class="fad fa-sliders-h me-2"></i> {{ $t("CRUD.Update.main_title") }}
      </h3>
    </div>

    <!-- UPDATE FORM WRAPPER -->
    <form @submit.prevent="validateCreateForm" v-if="country">
      <div class="container-fluid px-0">
        <!-- ================= SECTION 1: Pricing & Fees ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-coins text-warning me-2"></i> التسعير والرسوم
            الأساسية
          </h5>
          <div class="row">
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.vat"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.vat") }} (%)</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.price_km"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.price_km") }} (ر.س/كم)</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.return_restaurant_price_km"
                />
                <label class="form-label"
                  >{{
                    $t("settings.contactData.return_restaurant_price_km")
                  }}
                  (ر.س/كم)</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.base_fire_price"
                />
                <label class="form-label">سعر فتحة العداد (الأساسي)</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.base_fire_km"
                />
                <label class="form-label">عدد الكيلومتر الثابت</label>
              </div>
            </div>

            <!-- <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee"
                />
                <label class="form-label">{{ $t("settings.service_fee") }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_female"
                />
                <label class="form-label">{{ $t("settings.service_fee_female") }}</label>
              </div>
            </div> -->

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_client_app"
                />
                <label class="form-label">{{
                  $t("settings.service_fee_client_app")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_website"
                />
                <label class="form-label">{{
                  $t("settings.service_fee_website")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_driver_request"
                />
                <label class="form-label">{{
                  $t("settings.service_fee_driver_request")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_client_app_female"
                />
                <label class="form-label">{{
                  $t("settings.service_fee_client_app_female")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_website_female"
                />
                <label class="form-label">{{
                  $t("settings.service_fee_website_female")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.service_fee_driver_request_female"
                />
                <label class="form-label">{{
                  $t("settings.service_fee_driver_request_female")
                }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= SECTION 2: Commissions & Rates ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-chart-pie text-purple me-2"></i> نسب التطبيق
            والعمولات
          </h5>
          <div class="row">
            <!-- App Amount -->
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <label class="form-label">نوع نسبة التطبيق العامة</label>
                <multiselect
                  v-model="updateData.app_amount_type"
                  :options="app_amount_types"
                  label="name"
                  track-by="value"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.app_amount"
                />
                <label class="form-label">{{
                  $t("settings.contactData.app_amount")
                }}</label>
              </div>
            </div>

            <!-- Driver Amount -->
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <label class="form-label">نوع نسبة السائق</label>
                <multiselect
                  v-model="updateData.company_driver_app_amount_type"
                  :options="app_amount_types"
                  label="name"
                  track-by="value"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.company_driver_app_amount"
                />
                <label class="form-label">نسبة السائق</label>
              </div>
            </div>

            <!-- Restaurant Amount -->
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <label class="form-label">نوع نسبة المتجر</label>
                <multiselect
                  v-model="updateData.restaurant_app_amount_type"
                  :options="app_amount_types"
                  label="name"
                  track-by="value"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.restaurant_app_amount"
                />
                <label class="form-label">نسبة المتجر</label>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= SECTION 3: Order Limits & Auto Cancel ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-hourglass-half text-info me-2"></i> إعدادات حدود
            الطلبات وتوقيت الإلغاء
          </h5>
          <div class="row">
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.order_time_auto_cancel"
                />
                <label class="form-label">
                  {{ $t("settings.contactData.order_time_auto_cancel") }}
                  (للسائق)
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.restaurant_order_time_auto_cancel"
                />
                <label class="form-label">
                  {{ $t("settings.contactData.order_time_auto_cancel") }}
                  (للمطعم)
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.driver_request_area"
                />
                <label class="form-label">نطاق البحث عن السائقين (كم)</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.driver_batch_end_location_distance"
                />
                <label class="form-label">
                  {{ $t("settings.driver_batch_end_location_distance") }}
                </label>
              </div>
            </div>

            <div
              class="col-lg-6 py-2"
              v-for="field in driverAssignmentFields"
              :key="field.key"
            >
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  :min="field.allowZero ? 0 : 0.000001"
                  :disabled="isLoadingSettings"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData[field.key]"
                />
                <label class="form-label">{{ $t("settings." + field.key) }}</label>
              </div>
            </div>

            <!-- Creative Smart Dispatch Strategy & Priority Cockpit -->
            <div class="col-12 py-3">
              <div class="dispatch-strategy-showcase">
                <!-- Part 1: Driver Assignment Mode Selector -->
                <div class="strategy-header d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                  <div class="d-flex align-items-center gap-2">
                    <div class="strategy-orb-icon">
                      <i class="fad fa-project-diagram"></i>
                    </div>
                    <div>
                      <label class="strategy-main-title font-weight-bold d-block mb-0">
                        {{ $t("settings.driver_assignment_mode") }}
                      </label>
                      <span class="strategy-subtitle text-muted">
                        اختر آلية إرسال عروض الطلبات الجديدة إلى المناديب المتاحين
                      </span>
                    </div>
                  </div>
                  <span
                    v-if="updateData.driver_assignment_mode"
                    class="active-mode-pill"
                  >
                    <span class="pulse-dot"></span>
                    {{
                      $t(
                        "settings.driver_assignment_mode_" +
                          updateData.driver_assignment_mode
                      )
                    }}
                  </span>
                </div>

                <v-radio-group
                  v-model="updateData.driver_assignment_mode"
                  row
                  hide-details
                  :disabled="isLoadingSettings"
                  class="strategy-radio-group mt-0 pt-0 mb-4"
                >
                  <div class="row w-100 mx-0">
                    <div
                      v-for="mode in driverAssignmentModes"
                      :key="mode"
                      class="col-md-6 px-2 py-1"
                    >
                      <div
                        class="mode-option-card"
                        :class="{
                          'is-selected':
                            updateData.driver_assignment_mode === mode,
                          'is-disabled': isLoadingSettings,
                        }"
                        @click="
                          !isLoadingSettings &&
                            (updateData.driver_assignment_mode = mode)
                        "
                      >
                        <div class="mode-card-top d-flex align-items-center justify-content-between gap-2">
                          <div class="d-flex align-items-center gap-3">
                            <div
                              class="mode-icon-box"
                              :class="
                                mode === 'sequential'
                                  ? 'mode-icon-sequential'
                                  : 'mode-icon-broadcast'
                              "
                            >
                              <i
                                :class="
                                  mode === 'sequential'
                                    ? 'fad fa-stream'
                                    : 'fad fa-broadcast-tower'
                                "
                              ></i>
                            </div>
                            <div>
                              <span class="mode-title d-block font-weight-bold">
                                {{
                                  $t("settings.driver_assignment_mode_" + mode)
                                }}
                              </span>
                              <span class="mode-desc d-block text-muted">
                                {{
                                  mode === "sequential"
                                    ? "إرسال العرض للمندوب الأقرب أولاً ثم الانتقال للتالي تلقائياً"
                                    : "إرسال العرض لجميع المناديب المؤهلين في النطاق في نفس اللحظة"
                                }}
                              </span>
                            </div>
                          </div>

                          <div class="mode-radio-holder" @click.stop>
                            <v-radio
                              :value="mode"
                              :label="
                                $t('settings.driver_assignment_mode_' + mode)
                              "
                              color="#783D73"
                              class="sr-only-label-radio mb-0"
                            ></v-radio>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-radio-group>

                <!-- Part 2: Smart Assignment & Busy Driver Priority Toggles -->
                <div class="row">
                  <!-- Card A: Direct Admin Assignment for Extra Order -->
                  <div class="col-lg-6 py-2">
                    <div
                      class="dispatch-toggle-card h-100"
                      :class="{
                        'is-active': updateData.admin_assignment_direct_assign,
                        'is-disabled': isLoadingSettings,
                      }"
                      @click="
                        !isLoadingSettings &&
                          (updateData.admin_assignment_direct_assign =
                            !updateData.admin_assignment_direct_assign)
                      "
                    >
                      <div class="toggle-card-header d-flex align-items-start justify-content-between gap-2">
                        <div class="d-flex align-items-center gap-3">
                          <div class="toggle-icon-badge icon-direct">
                            <i class="fad fa-user-check"></i>
                          </div>
                          <div>
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <h6 class="toggle-title font-weight-bold mb-0">
                                {{ $t("settings.admin_assignment_direct_assign") }}
                              </h6>
                              <span
                                class="toggle-state-chip"
                                :class="
                                  updateData.admin_assignment_direct_assign
                                    ? 'chip-on'
                                    : 'chip-off'
                                "
                              >
                                {{
                                  updateData.admin_assignment_direct_assign
                                    ? "مفعّل"
                                    : "غير مفعّل"
                                }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="toggle-control-wrap" @click.stop>
                          <v-checkbox
                            :label="$t('settings.admin_assignment_direct_assign')"
                            :hint="$t('settings.admin_assignment_direct_assign_hint')"
                            persistent-hint
                            :disabled="isLoadingSettings"
                            v-model="updateData.admin_assignment_direct_assign"
                            color="#783D73"
                            class="compact-control-widget mt-0 pt-0"
                          ></v-checkbox>
                        </div>
                      </div>

                      <div class="toggle-hint-box mt-3">
                        <i class="far fa-info-circle hint-icon"></i>
                        <span>{{
                          $t("settings.admin_assignment_direct_assign_hint")
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Card B: Busy Drivers Priority in Delivery Offers -->
                  <div class="col-lg-6 py-2">
                    <!-- Only takes effect when the batch end location distance is > 0;
                         while it's empty the switch can be turned off but not on -->
                    <div
                      class="dispatch-toggle-card h-100"
                      :class="{
                        'is-active': updateData.driver_batch_priority_enabled,
                        'is-warning':
                          !hasBatchEndLocationDistance &&
                          !updateData.driver_batch_priority_enabled,
                        'has-error':
                          fieldErrors.driver_batch_priority_enabled,
                        'is-disabled':
                          isLoadingSettings ||
                          (!hasBatchEndLocationDistance &&
                            !updateData.driver_batch_priority_enabled),
                      }"
                      @click="
                        !(
                          isLoadingSettings ||
                          (!hasBatchEndLocationDistance &&
                            !updateData.driver_batch_priority_enabled)
                        ) &&
                          ((updateData.driver_batch_priority_enabled =
                            !updateData.driver_batch_priority_enabled),
                          clearFieldError('driver_batch_priority_enabled'))
                      "
                    >
                      <div class="toggle-card-header d-flex align-items-start justify-content-between gap-2">
                        <div class="d-flex align-items-center gap-3">
                          <div class="toggle-icon-badge icon-priority">
                            <i class="fad fa-shipping-fast"></i>
                          </div>
                          <div>
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <h6 class="toggle-title font-weight-bold mb-0">
                                {{
                                  $t("settings.driver_batch_priority_enabled")
                                }}
                              </h6>
                              <span
                                class="toggle-state-chip"
                                :class="
                                  updateData.driver_batch_priority_enabled
                                    ? 'chip-on'
                                    : 'chip-off'
                                "
                              >
                                {{
                                  updateData.driver_batch_priority_enabled
                                    ? "مفعّل"
                                    : "غير مفعّل"
                                }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="toggle-control-wrap" @click.stop>
                          <v-switch
                            :label="$t('settings.driver_batch_priority_enabled')"
                            :hint="
                              hasBatchEndLocationDistance
                                ? $t('settings.driver_batch_priority_enabled_hint')
                                : $t(
                                    'settings.driver_batch_priority_enabled_requires_distance'
                                  )
                            "
                            persistent-hint
                            :error-messages="
                              fieldErrors.driver_batch_priority_enabled
                            "
                            :disabled="
                              isLoadingSettings ||
                              (!hasBatchEndLocationDistance &&
                                !updateData.driver_batch_priority_enabled)
                            "
                            v-model="updateData.driver_batch_priority_enabled"
                            @change="
                              clearFieldError('driver_batch_priority_enabled')
                            "
                            color="#783D73"
                            class="compact-control-widget mt-0 pt-0"
                          ></v-switch>
                        </div>
                      </div>

                      <div
                        class="toggle-hint-box mt-3"
                        :class="{
                          'hint-warning': !hasBatchEndLocationDistance,
                        }"
                      >
                        <i
                          :class="
                            hasBatchEndLocationDistance
                              ? 'far fa-sparkles hint-icon'
                              : 'far fa-exclamation-triangle hint-icon text-warning'
                          "
                        ></i>
                        <span>{{
                          hasBatchEndLocationDistance
                            ? $t("settings.driver_batch_priority_enabled_hint")
                            : $t(
                                "settings.driver_batch_priority_enabled_requires_distance"
                              )
                        }}</span>
                      </div>

                      <div
                        v-if="fieldErrors.driver_batch_priority_enabled"
                        class="toggle-error-banner mt-2"
                      >
                        <i class="far fa-times-circle ml-1"></i>
                        {{ fieldErrors.driver_batch_priority_enabled }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.restaurant_search_by_kilo"
                />
                <label class="form-label">نطاق البحث عن المتاجر (كم)</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.referral_code_price"
                />
                <label class="form-label"
                  >قيمة مشاركة التطبيق (مكافأة الإحالة)</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="
                    updateData.decrment_amount_form_restaurant_when_reject_order_from_her_website
                  "
                />
                <label class="form-label">
                  {{
                    $t(
                      "settings.decrment_amount_form_restaurant_when_reject_order_from_her_website"
                    )
                  }}
                </label>
              </div>
            </div>

            <div
              class="col-lg-6 py-2"
              v-for="field in orderDelayFields"
              :key="field.key"
            >
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="1"
                  min="1"
                  class="form-control"
                  :class="{ 'is-invalid': fieldErrors[field.key] }"
                  :placeholder="field.defaultValue"
                  :disabled="isLoadingSettings"
                  @input="checkIfInputIsEmpty($event), clearFieldError(field.key)"
                  v-model.trim="updateData[field.key]"
                />
                <label class="form-label">{{ $t("settings." + field.key) }}</label>
              </div>
              <small
                v-if="fieldErrors[field.key]"
                class="d-block text-danger mt-1"
                >{{ fieldErrors[field.key] }}</small
              >
              <small
                v-else-if="field.defaultValue && isEmptyValue(updateData[field.key])"
                class="d-block text-muted mt-1"
                >{{
                  $t("settings.effective_default_minutes", {
                    value: field.defaultValue,
                  })
                }}</small
              >
            </div>
          </div>
        </div>

        <!-- ================= SECTION 4: Wallet & Withdrawal Limits ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-wallet text-success me-2"></i> المحفظة وحدود السحب
            والإيداع
          </h5>
          <div class="row">
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.min_limit_charge"
                />
                <label class="form-label">أقل قيمة للشحن</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.minimum_wallet_to_receive_order"
                />
                <label class="form-label"
                  >اقل رصيد للسائق لاستلام الطلبات</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="
                    updateData.minimum_wallet_to_receive_order_for_store
                  "
                />
                <label class="form-label"
                  >اقل رصيد في المحفظة لاستلام الطلبات من المتجر</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.min_limit_withdrawal"
                />
                <label class="form-label">الحد الأدني لسحب رصيد للعملاء</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.min_limit_withdrawal_restaurant"
                />
                <label class="form-label">الحد الأدني لسحب رصيد للمتاجر</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.min_limit_withdrawal_driver"
                />
                <label class="form-label">الحد الأدني لسحب رصيد للسائق</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="
                    updateData.min_limit_withdrawal_delegate_company
                  "
                />
                <label class="form-label"
                  >الحد الأدني لسحب رصيد لشركات المناديب</label
                >
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  min="0"
                  :disabled="isLoadingSettings"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.restaurant_cash_settlement_debt_limit"
                />
                <label class="form-label">{{
                  $t("settings.restaurant_cash_settlement_debt_limit")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.max_daily_deposit_amount_per_user"
                />
                <label class="form-label">{{
                  $t("settings.max_daily_deposit_amount_per_user")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="
                    updateData.max_invoice_amount_per_order_delivery
                  "
                />
                <label class="form-label">{{
                  $t("settings.max_invoice_amount_per_order_delivery")
                }}</label>
              </div>
            </div>

            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.max_invoice_amount_per_order_package"
                />
                <label class="form-label">{{
                  $t("settings.max_invoice_amount_per_order_package")
                }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= SECTION 5: Gas Cylinders Prices ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-gas-pump text-danger me-2"></i> أسعار أسطوانات
            الغاز
          </h5>
          <div class="row">
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.cylinder_large_price"
                />
                <label class="form-label">{{
                  $t("settings.cylinder_larage_price")
                }}</label>
              </div>
            </div>

            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.cylinder_medium_price"
                />
                <label class="form-label">{{
                  $t("settings.cylinder_medium_price")
                }}</label>
              </div>
            </div>

            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.cylinder_small_price"
                />
                <label class="form-label">{{
                  $t("settings.cylinder_smalle_price")
                }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= SECTION 6: Social & Support Links ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-share-alt text-primary me-2"></i> روابط الدعم وسائل
            التواصل الاجتماعي
          </h5>

          <!-- General Email -->
          <div class="row mb-3">
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="email"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.email"
                />
                <label class="form-label">{{
                  $t("settings.contactData.email")
                }}</label>
              </div>
            </div>
          </div>

          <!-- Client Social Links -->
          <h6 class="font-weight-bold text-dark mt-3 mb-3">
            <i class="fad fa-user me-1 text-purple"></i> حسابات العميل
          </h6>
          <div class="row">
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.whatsapp_client"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.whatsapp") }} (للعميل)</label
                >
              </div>
            </div>
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.facebook_client"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.facebook") }} (للعميل)</label
                >
              </div>
            </div>
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.youtube_client"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.youtube") }} (للعميل)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.instagram_client"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.instagram") }} (للعميل)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.tiktok_client"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.tiktok") }} (للعميل)</label
                >
              </div>
            </div>
          </div>

          <!-- Driver Social Links -->
          <h6 class="font-weight-bold text-dark mt-4 mb-3">
            <i class="fad fa-steering-wheel me-1 text-primary"></i> حسابات
            السائق
          </h6>
          <div class="row">
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.whatsapp_driver"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.whatsapp") }} (للسائق)</label
                >
              </div>
            </div>
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.facebook_driver"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.facebook") }} (للسائق)</label
                >
              </div>
            </div>
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.youtube_driver"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.youtube") }} (للسائق)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.instagram_driver"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.instagram") }} (للسائق)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.tiktok_driver"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.tiktok") }} (للسائق)</label
                >
              </div>
            </div>
          </div>

          <!-- Restaurant Social Links -->
          <h6 class="font-weight-bold text-dark mt-4 mb-3">
            <i class="fad fa-store me-1 text-success"></i> حسابات المتجر
          </h6>
          <div class="row">
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.whatsapp_restaurant"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.whatsapp") }} (للمتجر)</label
                >
              </div>
            </div>
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.facebook_restaurant"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.facebook") }} (للمتجر)</label
                >
              </div>
            </div>
            <div class="col-lg-4 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.youtube_restaurant"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.youtube") }} (للمتجر)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.instagram_restaurant"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.instagram") }} (للمتجر)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.tiktok_restaurant"
                />
                <label class="form-label"
                  >{{ $t("settings.contactData.tiktok") }} (للمتجر)</label
                >
              </div>
            </div>
          </div>
        </div>

        <!-- ================= SECTION 7: Feature Toggles ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-toggle-on text-success me-2"></i> تفعيل وتعطيل
            خدمات ومميزات النظام
          </h5>
          <div class="row">
            <div class="col-lg-4 col-md-6 py-2">
              <v-checkbox
                :label="$t('forms.labels.can_pay_cash_in_website')"
                v-model="updateData.can_pay_cash_in_website"
                color="#783D73"
              ></v-checkbox>
            </div>

            <div class="col-lg-4 col-md-6 py-2">
              <v-checkbox
                :label="$t('forms.labels.is_package_service_available')"
                v-model="updateData.is_package_service_available"
                color="#783D73"
              ></v-checkbox>
            </div>

            <div class="col-lg-4 col-md-6 py-2">
              <v-checkbox
                :label="$t('forms.labels.has_female_service')"
                v-model="updateData.has_female_service"
                color="#783D73"
              ></v-checkbox>
            </div>

            <div class="col-lg-4 col-md-6 py-2">
              <v-checkbox
                :label="$t('forms.labels.district_coverage_enabled')"
                v-model="updateData.district_coverage_enabled"
                color="#783D73"
              ></v-checkbox>
            </div>

            <div class="col-lg-4 col-md-6 py-2">
              <v-checkbox
                :label="
                  $t('forms.labels.district_coverage_fallback_to_distance')
                "
                v-model="updateData.district_coverage_fallback_to_distance"
                color="#783D73"
              ></v-checkbox>
            </div>

            <div class="col-lg-4 col-md-6 py-2">
              <v-checkbox
                :label="$t('forms.labels.delivery_price_from_district')"
                v-model="updateData.delivery_price_from_district"
                color="#783D73"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <!-- ================= SECTION 8: Location & Map ================= -->
        <div class="section-card mb-4 p-4 rounded-xl shadow-sm border">
          <h5
            class="section-card-title mb-4 pb-2 border-bottom font-weight-bold"
            style="color: #783d73"
          >
            <i class="fad fa-map-marked-alt text-info me-2"></i> موقع الإدارة
            على الخريطة
          </h5>

          <div class="input_wrapper top_label mb-4">
            <input
              type="text"
              class="form-control"
              id="autocomplete_ar"
              placeholder=""
              @input="getAddressAr"
              v-model="updateData.location"
            />
            <label class="form-label">العنوان التفصيلي</label>
          </div>

          <div class="map-wrapper border rounded-xl overflow-hidden shadow-sm">
            <GmapMap
              :center="center"
              :zoom="12"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
            >
              <GmapMarker
                v-for="(m, index) in markers"
                :key="index"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @drag="updateCoordinates"
                @click="clickMethod(m)"
              />
            </GmapMap>
          </div>
        </div>
      </div>

      <!-- Submit Action Button -->
      <div
        class="buttons_wrapper text-center my-4"
        v-if="helper_hasPermission('add')"
      >
        <button
          class="button_style_1 btn-lg px-12"
          :class="btnIsLoading ? 'disabled' : ''"
        >
          {{ $t("forms.submit") }}
          <span class="btn_loader" v-if="btnIsLoading"></span>
        </button>
      </div>
    </form>

    <h1 v-else class="text-center main_color mt-10">يرجي اختيار دولة اولا</h1>
  </div>
</template>

<script>
export default {
  name: "Update",
  data() {
    return {
      btnIsLoading: false,
      isLoadingSettings: true,

      updateData: {
        app_name: null,
        app_link: null,
        phone: null,
        email: null,
        whatsapp_client: null,
        facebook_client: null,
        twitter_client: null,
        youtube_client: null,
        instagram_client: null,
        whatsapp_driver: null,
        facebook_driver: null,
        twitter_driver: null,
        youtube_driver: null,
        instagram_driver: null,
        whatsapp_restaurant: null,
        facebook_restaurant: null,
        tiktok_restaurant: null,
        youtube_restaurant: null,
        instagram_restaurant: null,
        app_store_app: null,
        g_play_app: null,
        driver: null,
        host: null,
        port: null,
        username: null,
        encry: { name: null },
        from_name: null,
        // service_fee: null,
        location: null,
        from_location: null,
        use_sms_service: null,
        sms_provider: null,
        sms_username: null,
        sms_password: null,
        sms_sender_name: null,
        app_amount_type: null,
        app_amount: null,
        price_kmsms_sender_name: null,
        return_restaurant_price_km: null,
        vat: null,
        tiktok: null,
        order_time_auto_cancel: null,
        order_delay_support_receive_minutes: null,
        order_delay_assign_driver_minutes: null,
        order_delay_driver_arrival_minutes: null,
        order_delay_driver_receive_minutes: null,
        order_delay_finish_per_km_minutes: null,
        company_driver_app_amount_type: null,
        map_api: null,
        restaurant_order_time_auto_cancel: null,
        is_package_service_available: false,
        has_female_service: false,
        district_coverage_enabled: false,
        district_coverage_fallback_to_distance: false,
        delivery_price_from_district: false,
        admin_assignment_direct_assign: false,
        // Missing from GET (staged rollout) means off
        driver_batch_priority_enabled: false,
        driver_batch_end_location_distance: null,
        // service_fee_female: null,
        service_fee_client_app: null,
        service_fee_website: null,
        service_fee_driver_request: null,
        service_fee_client_app_female: null,
        service_fee_website_female: null,
        service_fee_driver_request_female: null,
        cylinder_large_price: null,
        cylinder_medium_price: null,
        cylinder_small_price: null,
        max_daily_deposit_amount_per_user: null,
        max_invoice_amount_per_order_delivery: null,
        max_invoice_amount_per_order_package: null,
        decrment_amount_form_restaurant_when_reject_order_from_her_website:
          null,
        can_pay_cash_in_website: false,
        base_fire_price: null,
        base_fire_km: null,
        min_limit_withdrawal: null,
        min_limit_withdrawal_restaurant: null,
        min_limit_withdrawal_driver: null,
        min_limit_withdrawal_delegate_company: null,
        restaurant_cash_settlement_debt_limit: null,
        driver_store_proximity_radius_meters: null,
        driver_customer_proximity_radius_meters: null,
        driver_candidate_timeout_seconds: null,
        driver_assignment_round_delay_seconds: null,
        driver_assignment_mode: null,
      },

      driverAssignmentModes: ["sequential", "broadcast"],

      // allowZero: round delay may be 0, the others must be strictly positive
      driverAssignmentFields: [
        { key: "driver_store_proximity_radius_meters", allowZero: false },
        { key: "driver_customer_proximity_radius_meters", allowZero: false },
        { key: "driver_candidate_timeout_seconds", allowZero: false },
        { key: "driver_assignment_round_delay_seconds", allowZero: true },
      ],

      // Order delay limits: optional whole minutes >= 1. `defaultValue` is the
      // backend default shown while empty; it is never sent unless typed.
      orderDelayFields: [
        { key: "order_delay_support_receive_minutes", defaultValue: "2" },
        { key: "order_delay_assign_driver_minutes" },
        { key: "order_delay_driver_arrival_minutes" },
        { key: "order_delay_driver_receive_minutes" },
        { key: "order_delay_finish_per_km_minutes" },
      ],
      // Backend 422 messages, keyed by setting
      fieldErrors: {},

      encryValue: [
        { name: "ssl", value: "ssl" },
        { name: "tls", value: "tls" },
      ],
      smsStatus: [
        { name: "مفعل", value: "enable" },
        { name: "غير مفعل", value: "disable" },
      ],
      smsProviders: [
        { name: "HISMS", value: "hisms" },
        { name: "Net powers", value: "net_powers" },
        { name: "SMS Gateway", value: "sms_gateway" },
      ],
      app_amount_types: [
        {
          value: "amount",
          name: "قيمة",
        },
        {
          value: "percentage",
          name: "نسبة",
        },
      ],
      center: {
        lat: 0,
        lng: 0,
      },

      markers: [],
      coordinates_to_edit: { lat: 0, lng: 0 },
      country: localStorage.getItem("zoz_dash_country"),
    };
  },

  methods: {
    updateCoordinates(location) {
      this.updateData.lat = location.latLng.lat();
      this.updateData.lng = location.latLng.lng();
    },

    clickMethod(m) {
      this.center = m.position;
    },

    getAddressAr() {
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      if (!input || typeof google === "undefined" || !google.maps) return;
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          self.updateData.location = place.formatted_address;
          self.center.lat = place.geometry.location.lat();
          self.center.lng = place.geometry.location.lng();
          self.updateData.lat = place.geometry.location.lat();
          self.updateData.lng = place.geometry.location.lng();
          self.markers = [
            {
              position: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
              },
            },
          ];
        });
      });
    },

    checkIfInputIsEmpty(e) {
      let inputElement = e.currentTarget;
      if (inputElement.value.length > 0) {
        inputElement.classList.add("not_empty");
      } else {
        inputElement.classList.remove("not_empty");
      }
    },

    isEmptyValue(value) {
      return value === null || value === "" || value === undefined;
    },

    clearFieldError(key) {
      if (this.fieldErrors[key]) this.$delete(this.fieldErrors, key);
    },

    getData() {
      this.isLoadingSettings = true;
      this.$axios({
        method: "GET",
        url: "setting",
      })
        .finally(() => {
          this.isLoadingSettings = false;
        })
        .then((res) => {
        const result = res.data.data;
        result.map((el) => {
          if (el.key == "encry") {
            this.updateData[el.key] = {
              name: el.value,
              value: el.value,
            };
          } else if (el.key == "sms_provider") {
            this.updateData[el.key] = {
              name: el.value,
              value: el.value,
            };
          } else if (el.key == "use_sms_service") {
            this.updateData[el.key] = {
              name: el.value,
              value: el.value,
            };
          } else if (el.key == "app_amount_type") {
            this.updateData[el.key] = this.app_amount_types.find(
              (ele) => el.value == ele.value
            );
          } else if (el.key == "company_driver_app_amount_type") {
            this.updateData[el.key] = this.app_amount_types.find(
              (ele) => el.value == ele.value
            );
          } else if (el.key == "restaurant_app_amount_type") {
            this.updateData[el.key] = this.app_amount_types.find(
              (ele) => el.value == ele.value
            );
          } else if (el.key == "is_package_service_available") {
            if (el.value == "0") {
              this.updateData[el.key] = false;
            } else {
              this.updateData[el.key] = true;
            }
          } else if (el.key == "has_female_service") {
            if (el.value == "0") {
              this.updateData[el.key] = false;
            } else {
              this.updateData[el.key] = true;
            }
          } else if (el.key == "can_pay_cash_in_website") {
            if (el.value == "0") {
              this.updateData[el.key] = false;
            } else {
              this.updateData[el.key] = true;
            }
          } else if (el.key == "district_coverage_enabled") {
            this.updateData[el.key] =
              el.value == "1" || el.value === true || el.value == "true";
          } else if (el.key == "district_coverage_fallback_to_distance") {
            this.updateData[el.key] =
              el.value == "1" || el.value === true || el.value == "true";
          } else if (el.key == "delivery_price_from_district") {
            this.updateData[el.key] =
              el.value == "1" || el.value === true || el.value == "true";
          } else if (el.key == "admin_assignment_direct_assign") {
            this.updateData[el.key] =
              el.value == "1" || el.value === true || el.value == "true";
          } else if (el.key == "driver_batch_priority_enabled") {
            this.updateData[el.key] =
              el.value == "1" || el.value === true || el.value == "true";
          } else if (el.key == "address") {
            this.updateData.location = el.value;
          } else {
            this.updateData[el.key] = el.value;
          }

          if (el.key == "lat" && el.value) {
            this.center.lat = parseFloat(el.value);
          }
          if (el.key == "lng" && el.value) {
            this.center.lng = parseFloat(el.value);
          }
        });

        if (this.center.lat && this.center.lng) {
          this.markers = [
            {
              position: { lat: this.center.lat, lng: this.center.lng },
            },
          ];
        }
      });
    },

    validateCreateForm() {
      const debtLimit = this.updateData.restaurant_cash_settlement_debt_limit;
      if (
        debtLimit !== null &&
        debtLimit !== "" &&
        debtLimit !== undefined &&
        (isNaN(Number(debtLimit)) || Number(debtLimit) < 0)
      ) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("settings.restaurant_cash_settlement_debt_limit"),
          position: "bottomRight",
        });
        return;
      }
      for (const field of this.driverAssignmentFields) {
        const v = this.updateData[field.key];
        if (v === null || v === "" || v === undefined) continue;
        const n = Number(v);
        if (isNaN(n) || (field.allowZero ? n < 0 : n <= 0)) {
          this.$iziToast.error({
            timeout: 3000,
            message:
              this.$t(
                field.allowZero
                  ? "settings.driver_setting_must_be_non_negative"
                  : "settings.driver_setting_must_be_positive"
              ) +
              " " +
              this.$t("settings." + field.key),
            position: "bottomRight",
          });
          return;
        }
      }
      this.fieldErrors = {};
      for (const field of this.orderDelayFields) {
        const v = this.updateData[field.key];
        if (this.isEmptyValue(v)) continue;
        if (!/^\d+$/.test(String(v)) || Number(v) < 1) {
          this.$set(
            this.fieldErrors,
            field.key,
            this.$t("settings.must_be_positive_integer")
          );
        }
      }
      if (Object.keys(this.fieldErrors).length) {
        this.$iziToast.error({
          timeout: 3000,
          message: this.$t("settings.must_be_positive_integer"),
          position: "bottomRight",
        });
        return;
      }
      this.btnIsLoading = true;
      const data = new FormData();
      const zeroAllowedKeys = this.driverAssignmentFields
        .filter((f) => f.allowZero)
        .map((f) => f.key);
      for (const [key, value] of Object.entries(this.updateData)) {
        if (zeroAllowedKeys.includes(key)) {
          // 0 is valid for these; the generic `value &&` check below would drop it
          if (value !== null && value !== "" && value !== undefined) {
            data.append(key, value);
          }
          continue;
        }
        if (key == "restaurant_cash_settlement_debt_limit") {
          // 0 is a valid limit; empty means no new limit in this request
          if (value !== null && value !== "" && value !== undefined) {
            data.append(key, value);
          }
          continue;
        }
        if (
          value &&
          key != "is_package_service_available" &&
          key != "has_female_service" &&
          key != "can_pay_cash_in_website" &&
          key != "district_coverage_enabled" &&
          key != "district_coverage_fallback_to_distance" &&
          key != "delivery_price_from_district" &&
          key != "admin_assignment_direct_assign" &&
          key != "driver_batch_priority_enabled"
        ) {
          if (typeof value == "object") {
            data.append(key, value.value);
          } else {
            data.append(key, value);
          }
        }
        if (key == "is_package_service_available") {
          data.append(key, +value);
        }
        if (key == "has_female_service") {
          data.append(key, +value);
        }
        if (key == "can_pay_cash_in_website") {
          data.append(key, +value);
        }
        if (key == "district_coverage_enabled") {
          data.append(key, +value);
        }
        if (key == "district_coverage_fallback_to_distance") {
          data.append(key, +value);
        }
        if (key == "delivery_price_from_district") {
          data.append(key, +value);
        }
        if (key == "admin_assignment_direct_assign") {
          data.append(key, +value);
        }
        if (key == "driver_batch_priority_enabled") {
          data.append(key, +!!value);
        }
      }
      this.$axios({
        method: "post",
        url: "setting",
        data: data,
      })
        .then((res) => {
          // Validation failure returned as { status: false, message }
          if (res.data && res.data.status === false) {
            if (res.data.errors) {
              const errors = {};
              Object.entries(res.data.errors).forEach(([key, messages]) => {
                errors[key] = Array.isArray(messages) ? messages[0] : messages;
              });
              this.fieldErrors = errors;
            }
            this.$iziToast.error({
              timeout: 2000,
              message: res.data.message,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          }
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          this.$router.push({ path: "/" });
        })
        .catch((err) => {
          const res = err.response || {};
          // Laravel 422: { errors: { key: ["message", ...] } }, shown by the field
          if (res.status === 422 && res.data && res.data.errors) {
            const errors = {};
            Object.entries(res.data.errors).forEach(([key, messages]) => {
              errors[key] = Array.isArray(messages) ? messages[0] : messages;
            });
            this.fieldErrors = errors;
          }
          this.$iziToast.error({
            timeout: 2000,
            message: (res.data && res.data.message) || err.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
  computed: {
    hasBatchEndLocationDistance() {
      return Number(this.updateData.driver_batch_end_location_distance) > 0;
    },
    shipping_on() {
      return [
        {
          id: "city",
          name: "مدينة",
        },
        {
          id: "distance",
          name: "مسافة",
        },
      ];
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.section-card {
  background: #ffffff;
  border-color: rgba(120, 61, 115, 0.12) !important;
  transition: all 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 10px 30px rgba(120, 61, 115, 0.08) !important;
}

.section-card-title {
  font-size: 1.15rem;
}

/* ================= Smart Dispatch Strategy & Priority Cockpit ================= */
.dispatch-strategy-showcase {
  background: linear-gradient(
    135deg,
    rgba(120, 61, 115, 0.03) 0%,
    rgba(248, 250, 252, 0.9) 55%,
    rgba(255, 251, 235, 0.45) 100%
  );
  border: 1.5px solid rgba(120, 61, 115, 0.14);
  border-radius: 20px;
  padding: 22px 20px;
  box-shadow: 0 8px 24px rgba(120, 61, 115, 0.04);
}

.strategy-orb-icon {
  width: 44px;
  height: 44px;
  border-radius: 13px;
  background: linear-gradient(135deg, #783d73, #9b4f95);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(120, 61, 115, 0.25);
}

.strategy-main-title {
  font-size: 15.5px;
  color: #1e293b;
}

.strategy-subtitle {
  font-size: 12px;
  display: block;
  margin-top: 2px;
}

.active-mode-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: rgba(120, 61, 115, 0.1);
  color: #783d73;
  border: 1px solid rgba(120, 61, 115, 0.22);
}

.active-mode-pill .pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

.strategy-radio-group ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}

/* Mode Option Cards (Sequential vs Broadcast) */
.mode-option-card {
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px 18px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  height: 100%;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.03);
}

.mode-option-card:hover:not(.is-disabled) {
  border-color: rgba(120, 61, 115, 0.45);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(120, 61, 115, 0.09);
}

.mode-option-card.is-selected {
  border-color: #783d73;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    rgba(250, 245, 255, 0.9) 100%
  );
  box-shadow: 0 8px 22px rgba(120, 61, 115, 0.14),
    0 0 0 2px rgba(120, 61, 115, 0.12);
}

.mode-option-card.is-disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.mode-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  transition: all 0.25s ease;
}

.mode-icon-sequential {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
}

.mode-icon-broadcast {
  background: rgba(120, 61, 115, 0.1);
  color: #783d73;
}

.mode-option-card.is-selected .mode-icon-sequential,
.mode-option-card.is-selected .mode-icon-broadcast {
  background: linear-gradient(135deg, #783d73, #9b4f95);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(120, 61, 115, 0.3);
}

.mode-title {
  font-size: 14.5px;
  color: #1e293b;
}

.mode-option-card.is-selected .mode-title {
  color: #783d73;
}

.mode-desc {
  font-size: 12px;
  line-height: 1.5;
  margin-top: 2px;
}

.sr-only-label-radio ::v-deep .v-label {
  display: none !important;
}

.sr-only-label-radio ::v-deep .v-input--selection-controls__input {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Interactive Feature Toggle Cards */
.dispatch-toggle-card {
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
}

.dispatch-toggle-card:hover:not(.is-disabled) {
  border-color: rgba(120, 61, 115, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(120, 61, 115, 0.08);
}

.dispatch-toggle-card.is-active {
  border-color: rgba(120, 61, 115, 0.55);
  border-right: 4px solid #783d73;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    rgba(250, 245, 255, 0.75) 100%
  );
  box-shadow: 0 8px 22px rgba(120, 61, 115, 0.1);
}

.dispatch-toggle-card.is-warning {
  border-style: dashed;
  border-color: rgba(245, 158, 11, 0.45);
}

.dispatch-toggle-card.has-error {
  border-color: #ef4444;
  background: #fffafa;
}

.dispatch-toggle-card.is-disabled {
  cursor: not-allowed;
  opacity: 0.78;
}

.toggle-icon-badge {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
  transition: all 0.25s ease;
}

.toggle-icon-badge.icon-direct {
  background: rgba(14, 165, 233, 0.1);
  color: #0284c7;
}

.toggle-icon-badge.icon-priority {
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
}

.dispatch-toggle-card.is-active .toggle-icon-badge {
  background: linear-gradient(135deg, #783d73, #9b4f95);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(120, 61, 115, 0.28);
}

.toggle-title {
  font-size: 14.5px;
  color: #1e293b;
  line-height: 1.4;
}

.toggle-state-chip {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
}

.toggle-state-chip.chip-on {
  background: rgba(16, 185, 129, 0.14);
  color: #047857;
  border: 1px solid rgba(16, 185, 129, 0.28);
}

.toggle-state-chip.chip-off {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

/* Hide duplicated Vuetify label/hint inside the compact control wrapper while keeping accessibility */
.compact-control-widget ::v-deep .v-label,
.compact-control-widget ::v-deep .v-messages {
  display: none !important;
}

.compact-control-widget ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}

.compact-control-widget ::v-deep .v-input--selection-controls__input {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.toggle-hint-box {
  background: #f8fafc;
  border: 1px solid #eef2f6;
  border-radius: 12px;
  padding: 10px 13px;
  font-size: 12.5px;
  color: #475569;
  line-height: 1.65;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.dispatch-toggle-card.is-active .toggle-hint-box {
  background: rgba(120, 61, 115, 0.04);
  border-color: rgba(120, 61, 115, 0.14);
  color: #334155;
}

.toggle-hint-box.hint-warning {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

.toggle-hint-box .hint-icon {
  margin-top: 4px;
  color: #783d73;
  flex-shrink: 0;
  font-size: 14px;
}

.toggle-error-banner {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 10px;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}
</style>
